import 'datatables.net-bs5';
import {Api, ConfigColumns, Order} from "datatables.net-bs5";
import DataTable, {AjaxData, Config} from "datatables.net";
import {get, init_tooltips, notifier, number_format, on, on_keyup, parent} from "../util";
import {crafting_link, gold, nwdb_link, update_motes} from "./util";
import {assetUrl} from "../utils/assetUrl";

interface PricesAjaxData extends AjaxData {
    crafting_id : number,
    column_names : string[],
    owned : boolean,
    items : number[]
}

export default class {
    static init = () => {
        list();
    }
}

function list() {
    let tables = document.querySelectorAll('.datatable[data-table="nw_prices"]') as NodeListOf<HTMLElement>;
    if(!tables) {
        return;
    }

    tables.forEach((table) => {
        let columns : ConfigColumns[] = [];
        let column_names: string[] = [];
        table.querySelectorAll('thead th').forEach((th) => {
            let name = th.getAttribute('data-col') ?? '';
            let column;
            switch(name) {
                case 'name':
                    column = {
                        data: null, className: "align-middle", render: function(data : any) {
                            return `<a href="/nw/item/${data.id}" class="text-decoration-none"><img src="https://cdn.nwdb.info/db/images/live/v50/icons/items/resource/${data.nw_id}.png" class="img-fluid" style="width:20px" /> ${data.name}</a>` + crafting_link(data.crafting) + nwdb_link(data.nw_id);
                        }
                    };
                    break;
                case 'price':
                    column = {
                        data: null, className: "align-middle", render: function(data : any) {
                            let color = data.price_percent == 50 ? '#fff' : (data.price_percent > 50 ? '#f00' : '#0f0');
                            return `<div class="progress progress-price js-price-edit" data-bs-toggle="tooltip" data-bs-html="true" title="<b>Low:</b> <img src='${assetUrl('nw/icons/gold.webp')}' class='img-fluid icon-gold' />${data.low}<br><b>High:</b> <img src='${assetUrl('nw/icons/gold.webp')}' class='img-fluid icon-gold' />${data.high}" data-price="${data.price_raw}" data-id="${data.id}">` +
                                `<div class="progress-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" style="width: ${data.price_percent}%; border-color: ${color}"></div>` +
                                `<div class="progress-bar-text"><span class="" data-price="${data.price_raw}" data-id="${data.id}">` +
                                    `<img src="${assetUrl('nw/icons/gold.webp')}" class="img-fluid" style="width: 17px" /> <b>${number_format(data.price_raw)}</b>` +
                                `</span></div>` +
                            `</div>`;
                        }
                    };
                    break;
                case 'price-percent':
                    column = {
                        data: null, className: "align-middle", render: function(data : any) {
                            return '';
                        }
                    };
                    break;
                case 'cost':
                    column = {
                        data: null, className: "align-middle", render: function(data : any) {
                            return gold(number_format(data.cost,0));
                        }
                    };
                    break;
                case 'cost-tokens':
                    column = {
                        data: null, className: "align-middle", render: function(data : any) {
                            return `<img src="${assetUrl('nw/icons/token2.webp')}" class="img-fluid" style="width: 22px" /> ${number_format(data.cost_tokens,0)}`
                        }
                    };
                    break;
                case 'profit':
                    column = {
                        data: null, className: "align-middle", render: function(data : any) {
                            return `<span style="color: ${data.profit_color}"><img src="${assetUrl('nw/icons/gold.webp')}" class="img-fluid" style="width: 22px" /> ${number_format(data.profit)}</span>`
                        }
                    };
                    break;
                case 'profit-per-token':
                    column = {
                        data: null, className: "align-middle", render: function(data : any) {
                            return `<span style="color: ${data.profit_per_token_color}"><img src="${assetUrl('nw/icons/gold.webp')}" class="img-fluid" style="width: 22px" /> ${number_format(data.profit_per_token)}</span>`
                        }
                    };
                    break;
                case 'amount':
                    column = {
                        data: null, className: "align-middle", render: function(data : any) {
                            return `<span class="js-amount-view" data-id="${data.id}">${data.amount}</span>`;
                        }
                    };
                    break;
                case 'amount-value':
                    column = {
                        data: null, className: "align-middle", render: function(data : any) {
                            return gold(number_format(data.amount_value));
                        }
                    };
                    break;
                case 'date-updated':
                    column = {data: 'date_updated', className: "align-middle"};
                    break;
                default:
                    column = {data: null};
                    break;
            }
            columns.push(column);
            column_names.push(name);
        });

        let order = [[column_names.indexOf('date-updated'), "desc"]] as Order[];
        if(column_names.includes('cost-tokens')) {
            order = [[column_names.indexOf('cost-tokens'), "desc"]] as Order[];
        }

        let settings = {
            pageLength: 20,
            lengthMenu: [10, 20, 50, 100],
            processing: true,
            serverSide: true,
            ajax: {
                url: '?do=getPrices',
                data: function (data: PricesAjaxData, settings) {
                    let search = settings.oPreviousSearch.search;

                    let search_attr = table.getAttribute('data-search') as string;
                    if(search_attr && search === '') {
                        data.search.value = search_attr;
                        search = search_attr;
                    }

                    let owned = document.getElementById('filter-owned') as HTMLInputElement;
                    data.owned = owned && owned.checked;

                    let crafting_id = table.getAttribute('data-crafting_id');
                    if(crafting_id) {
                        data.crafting_id = parseInt(crafting_id);
                    }

                    let items_json = table.getAttribute('data-items');
                    if(items_json) {
                        data.items = JSON.parse(items_json);
                    }

                    data.column_names = column_names;
                    let gold = document.querySelector('.js-gold') as HTMLElement;
                    if(gold) {
                        get('?do=getItemGold', {search: search}, (data: any) => {
                            if(data) {
                                gold.innerText = number_format(data);
                            }
                        });
                    }
                    return data;
                }
            },
            columns: columns,
            drawCallback: init_tooltips,
            order: order
        } as Config;

        if(table.getAttribute('data-hide-all')) {
            settings.dom = "<'row'<'col-sm-12'tr>>";
        }

        let nw_prices = new DataTable(table, settings);

        on('change', '#filter-owned', (target: HTMLInputElement) => {
            nw_prices.ajax.reload();
        });

        on('focusout','.js-price-edit-input',(target : HTMLInputElement) => update_price_from_table(nw_prices,target),true);
        on_keyup(13,'.js-price-edit-input',(target : HTMLInputElement) => update_price_from_table(nw_prices,target));

        on('focusout','.js-amount-edit',(target : HTMLInputElement) => update_amount_from_table(nw_prices,target), true);
        on_keyup(13,'.js-amount-edit',(target : HTMLInputElement) => update_amount_from_table(nw_prices,target));
    });

    on('click', '.js-prices-update', (target: HTMLElement) => {
        let json = (document.querySelector('.js-prices-json') as HTMLInputElement).value;
        if(json !== '') {
            target.setAttribute('disabled', '');
            target.classList.add('disabled');
            let form = parent(target, 'form') as HTMLFormElement;
            form.submit();
        } else {
            notifier.warning('No JSON data to update.');
        }
    });

    on('click','.js-price-edit',(target: HTMLElement) => {
        let td = (target?.parentElement as HTMLElement);

        let value = target.getAttribute('data-price') ?? "0";

        let input = document.createElement('input');
        input.type = 'number';
        input.step = '0.01';
        input.value = value;
        input.classList.add('form-control', 'form-control-sm', 'js-price-edit-input');
        input.setAttribute('data-id', target.getAttribute('data-id') ?? "0");
        input.setAttribute('value', target.getAttribute('data-price') ?? "0");

        td.innerHTML = '';
        td.appendChild(input);

        input.focus();
        // setTimeout(function(){ input.selectionStart = input.selectionEnd = 10000; }, 0);
        // input.selectionStart = input.selectionEnd = value.length;

        document.querySelectorAll('.tooltip').forEach((el) => el.remove());
        // target.classList.remove('js-price');
    }, true);

    on('click','.js-amount-view',(target : HTMLElement) => {
        let td = (target?.parentElement as HTMLElement);

        let amount = target.innerText ?? "0";

        let input = document.createElement('input');
        input.type = 'number';
        input.step = '1';
        input.value = amount;
        input.classList.add('form-control', 'form-control-sm', 'js-amount-edit');
        input.setAttribute('data-id', target.getAttribute('data-id') ?? "0");

        td.innerHTML = '';
        td.appendChild(input);

        input.focus();
    },true);

    function update_price_from_table(table : Api<any>, target : HTMLInputElement) {
        let id = parseInt(target.getAttribute('data-id') ?? "0");
        let price = parseFloat(target.value);
        save_price(id, price, (data: any) => {
            table.ajax.reload();

            let crafting_id = parseInt(document.querySelector('.datatable[data-table="nw_prices"]')?.getAttribute('data-crafting_id') ?? "0");
            if(crafting_id) {
                update_crafting_calculations(crafting_id);
            }

            if(document.querySelector('.js-mote') !== null) {
                update_motes();
            }
        });
    }

    function update_amount_from_table(table : Api<any>, input: HTMLInputElement) {
        let id = parseInt(input.getAttribute('data-id') ?? "0");
        let amount = parseInt(input.value);
        get('?do=updateAmount', {item_id: id, amount: amount},(data : any) => {
            if(data) {
                notifier.success("Amount has been updated.");
            }
            table.ajax.reload();
        });
    }
}

function save_price(id : number, price : number, callback : Function) {
    get('?do=updatePrice', {item_id: id, price: price},(data : any) => {
        if(data) {
            notifier.success("Price has been updated.");
        }
        callback(data);
    });
}

function update_crafting_calculations(id : number) {
    get('?do=getCraftingCalculations', {crafting_id: id},(data : any) => {
        if(data.status == 1) {
            let cost = document.querySelector('.js-calc-cost') as HTMLElement;
            let min_sell = document.querySelector('.js-calc-min-sell') as HTMLElement;
            let sell = document.querySelector('.js-calc-sell') as HTMLElement;
            let profit = document.querySelector('.js-calc-profit') as HTMLElement;
            let profit_percent = document.querySelector('.js-calc-profit-percent') as HTMLElement;
            let sell_no_extra = document.querySelector('.js-calc-sell-no-extra') as HTMLElement;
            let profit_no_extra = document.querySelector('.js-calc-profit-no-extra') as HTMLElement;
            let profit_percent_no_extra = document.querySelector('.js-calc-profit-percent-no-extra') as HTMLElement;

            set_crafting_calculations_value(cost, data.cost);
            set_crafting_calculations_value(min_sell, data.min_sell);
            set_crafting_calculations_value(sell, data.sell);
            set_crafting_calculations_value(profit, data.profit, true);
            set_crafting_calculations_value(profit_percent, data.profit_percent, true, '%');
            set_crafting_calculations_value(sell_no_extra, data.sell_no_extra);
            set_crafting_calculations_value(profit_no_extra, data.profit_no_extra, true);
            set_crafting_calculations_value(profit_percent_no_extra, data.profit_percent_no_extra, true, '%');
        }
    });

    function set_crafting_calculations_value(element : HTMLElement, value : any, color : boolean = false, type : string = '$') {
        if(element) {
            element.innerHTML = type == '$' ? value : value + "%";
            if(color) {
                if(value < 0) {
                    element.classList.remove('text-success');
                    element.classList.add('text-danger');
                } else {
                    element.classList.remove('text-danger');
                    element.classList.add('text-success');
                }
            }
        }
    }
}
